import { FC } from 'react'

import CiscoLogo from '@/assets/logos/cisco.svg?react'
import ZoomLogo from '@/assets/logos/zoom.svg?react'
import ServiceIntegrationCard from '@/components/service-integration-card'
import { Settings } from '@/components/layout/settings/layout'
import SettingsTitle from '@/components/layout/settings/title'
import useObject from '@/hooks/useObject'
import TwilioConfiguration from '@/pages/settings/sms-configuration/twilio'
import { retrieveSMSConfiguration } from '@/thunks/sms/retrieve'
import fadeIn from '@/util/fadeIn'

const SMSConfiguration: FC = () => {
  const [configuration, { wasLoaded }] = useObject(retrieveSMSConfiguration, {})

  // Create sorted providers array with connected provider first
  const sortedProviders = () => {
    const providers = [
      {
        key: 'twilio',
        component: <TwilioConfiguration key="twilio" />,
        isConnected: !!configuration,
      },
      {
        key: 'cisco',
        component: (
          <ServiceIntegrationCard
            key="cisco"
            title="Cisco"
            description="Text messages will be sent from your Cisco SMS gateway"
            icon={<CiscoLogo className="w-8 h-8" />}
            iconColor="text-[#1BA0D7] dark:text-white"
            isConnected={false}
            disabled={true}
            disabledMessage="Contact Journey to enable Cisco SMS integration"
            setupContent={<div>Setup content placeholder</div>}
          />
        ),
        isConnected: false,
      },
      {
        key: 'zoom',
        component: (
          <ServiceIntegrationCard
            key="zoom"
            title="Zoom"
            description="Text messages will be sent from your Zoom SMS gateway"
            icon={<ZoomLogo className="w-8 h-8" />}
            iconColor="text-[#2D8CFF] dark:text-white"
            isConnected={false}
            disabled={true}
            disabledMessage="Contact Journey to enable Zoom SMS integration"
            setupContent={<div>Setup content placeholder</div>}
          />
        ),
        isConnected: false,
      },
    ]

    // Sort so connected provider appears first
    return providers.sort((a, b) => {
      if (a.isConnected && !b.isConnected) return -1
      if (!a.isConnected && b.isConnected) return 1
      return 0
    })
  }

  return (
    <Settings>
      <SettingsTitle
        title="SMS Configuration"
        subtitle="We use our shared Twilio account by default. Configure your own Twilio account below to use your custom
        phone number."
      />

      {wasLoaded && (
        <div className={fadeIn()}>
          <div className="space-y-4">{sortedProviders().map(provider => provider.component)}</div>
        </div>
      )}
    </Settings>
  )
}

export default SMSConfiguration
